import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { fetchBootstrap, track } from "@/lib/api";

const AppContext = createContext(null);

export function AppProvider({ children, initialData = null, trackVisits = true }) {
  const [data, setData] = useState(initialData);
  const [loading, setLoading] = useState(!initialData);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const boot = await fetchBootstrap();
      setData(boot);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!initialData) load();
  }, [load, initialData]);

  useEffect(() => {
    if (data && trackVisits) {
      track({ type: "visit", path: window.location.pathname });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!!data, trackVisits]);

  const settings = data?.settings || {};
  const platforms = data?.platforms || [];
  const tools = data?.tools || [];
  const ads = data?.ads || {};
  const pages = data?.pages || [];

  const getAd = (slotKey) => ads[slotKey];

  return (
    <AppContext.Provider
      value={{ loading, error, settings, platforms, tools, ads, pages, getAd, reload: load }}
    >
      {children}
    </AppContext.Provider>
  );
}

export const useApp = () => useContext(AppContext);
